<fs-tab-bar-offline *ngIf="isOffline" [titlePage]="offlinePageTitle"></fs-tab-bar-offline>

<h1 *ngIf="!this.isOffline">Nouveau mandat SEPA</h1>

<div class="pnl-form-mandat" [ngClass]="{'is-connected': !isOffline}">

  <h1
    *ngIf="isOffline && sepaMandateState === SignatureState.READY_TO_SIGN && signatureSepaState !== SignatureState.SIGNED">
    Finalisez votre souscription
  </h1>

  <!-- Display errors messages GetSepaState -->
  <div class="error" *ngIf="sepaMandateState === SignatureState.ERROR">
    <p>Une erreur est survenue. Nous vous invitons à réessayer plus tard.</p>
  </div>
  <div class="error" *ngIf="sepaMandateState === SignatureState.NOT_FOUND">
    <p>Une erreur est survenue.</p>
  </div>
  <div class="error" *ngIf="sepaMandateState === SignatureState.SIGNED && !isOrderAndSepaSign">
    <p>Vous avez déjà signé un Mandat SEPA.</p>
  </div>

  <!-- Form -->
  <div
    *ngIf="sepaMandateState === SignatureState.READY_TO_SIGN && (!isOrderAndSepaSign || signatureSepaState !== SignatureState.SIGNED)"
    class="pnl-global">

    <!-- Form -->
    <div [formGroup]="sepaMandateForm" class="pnl-form-data" [ngClass]="{'is-offline': isOffline}">

      <div *ngIf="signatureSepaState !== SignatureState.SIGNED" class="pnl-info">
        <h2 class="step-title">Coordonnées bancaires</h2>
        <div id="bank-block" class="data-block">
          <mat-form-field class="large-width">
            <input data-testid="sepa-mandate-iban" matInput id="Iban" formControlName="Iban" placeholder="IBAN"
              autofocus />
            <mat-error *ngIf="sepaMandateForm.controls.Iban.errors">
              {{getMessageError(sepaMandateForm.controls.Iban, 'sepaMandateForm.Iban')}}
            </mat-error>
          </mat-form-field>
          <mat-form-field class="large-width">
            <input data-testid="sepa-mandate-bic" matInput id="Bic" formControlName="Bic" placeholder="BIC"
              autofocus />
            <mat-error *ngIf="sepaMandateForm.controls.Bic.errors">
              {{getMessageError(sepaMandateForm.controls.Bic, 'sepaMandateForm.Bic')}}
            </mat-error>
          </mat-form-field>

          <mat-form-field class="large-width">
            <input data-testid="sepa-mandate-company-name" matInput type="text" id="RaisonSociale"
              formControlName="RaisonSociale" placeholder="Raison sociale ou Nom du débiteur" />
            <mat-error *ngIf="sepaMandateForm.controls.RaisonSociale.errors">
              {{getMessageError(sepaMandateForm.controls.RaisonSociale, 'sepaMandateForm.RaisonSociale')}}
            </mat-error>
          </mat-form-field>

          <mat-form-field class="all-width">
            <input data-testid="sepa-mandate-address" matInput id="Adresse" formControlName="Adresse"
              placeholder="Adresse du débiteur (N°, voie, rue)" (keyup)="searchTermSubject$.next($event.target.value)"
              autocomplete="new-password" />
            <mat-error *ngIf="sepaMandateForm.controls.Adresse.errors">
              {{getMessageError(sepaMandateForm.controls.Adresse, 'sepaMandateForm.Adresse')}}
            </mat-error>
          </mat-form-field>
          <div class="drop-container" *ngIf="addresses.length > 0">
            <div *ngFor="let address of addresses; let i = index" class="drop-option" [class.even]="i % 2 == 0"
              (click)="onAddressSelected(address)">
              {{ address.Display }}
            </div>
          </div>

          <div id="cp-city-block" class="large-width">
            <mat-form-field class="small-width">
              <input data-testid="sepa-mandate-postal-code" matInput id="Cp" formControlName="Cp"
                placeholder="Code Postal" />
              <mat-error *ngIf="sepaMandateForm.controls.Cp.errors">
                {{getMessageError(sepaMandateForm.controls.Cp, 'sepaMandateForm.Cp')}}
              </mat-error>
            </mat-form-field>

            <mat-form-field class="med-width">
              <input data-testid="sepa-mandate-city" matInput id="Ville" formControlName="Ville" placeholder="Ville" />
              <mat-error *ngIf="sepaMandateForm.controls.Ville.errors">
                {{getMessageError(sepaMandateForm.controls.Ville, 'sepaMandateForm.Ville')}}
              </mat-error>
            </mat-form-field>
          </div>

          <mat-form-field class="large-width">
            <input data-testid="sepa-mandate-country" matInput id="Pays" formControlName="Pays" placeholder="Pays" />
            <mat-error *ngIf="sepaMandateForm.controls.Pays.errors">
              {{getMessageError(sepaMandateForm.controls.Pays, 'sepaMandateForm.Pays')}}
            </mat-error>
          </mat-form-field>
        </div>

        <h2 class="step-title">Identité du signataire</h2>

        <div id="identity-block" class="data-block">
          <mat-form-field class="large-width">
            <input data-testid="sepa-mandate-first-name" matInput id="Prenom" formControlName="Prenom"
              placeholder="Prénom" />
            <mat-error *ngIf="sepaMandateForm.controls.Prenom.errors">
              {{getMessageError(sepaMandateForm.controls.Prenom, 'sepaMandateForm.Prenom')}}
            </mat-error>
          </mat-form-field>

          <mat-form-field class="large-width">
            <input data-testid="sepa-mandate-last-name" matInput id="Nom" formControlName="Nom" placeholder="Nom" />
            <mat-error *ngIf="sepaMandateForm.controls.Nom.errors">
              {{getMessageError(sepaMandateForm.controls.Nom, 'sepaMandateForm.Nom')}}
            </mat-error>
          </mat-form-field>
        </div>

      </div>

      <!-- Buttons -->
      <div *ngIf="signatureSepaState !== SignatureState.SIGNED || !isOffline" class="pnl-btn"
        [ngClass]="{'success-connected': !isOffline && signatureSepaState === SignatureState.SIGNED}">
        <div *ngIf="signatureSepaState !== SignatureState.SIGNED" class="btn-group">
          <button class="ui-btn secondary-btn" type="button" (click)="formBack()">
            Retour
          </button>
          <button *ngIf="!isOffline" class="ui-btn primary-btn" data-testid="sepa-mandate-submit" type="submit"
            (click)="generateSepa()" [disabled]="sepaMandateForm.invalid">
            Signer
          </button>
          <button *ngIf="isOffline" class="ui-btn primary-btn large-btn" data-testid="sepa-mandate-submit" type="submit"
            (click)="generateSepa()" [disabled]="sepaMandateForm.invalid">
            Signer le bon de commande et le mandat SEPA
          </button>
        </div>

      </div>

    </div>
  </div>

  <!-- Order-sepa common sign -->
  <div
    *ngIf="isOrderAndSepaSign && (signatureSepaState === SignatureState.SIGNED || sepaMandateState === SignatureState.SIGNED)"
    id="order-sepa-sign-success">
    <h1>Merci de votre confiance !</h1>
    <p>
      Nous avons bien reçu les documents signés et vous les avons envoyés par mail, ainsi qu'à votre commercial. <br />
      Vos prestations sont en cours d'activation. Cela peut prendre <b>jusqu'à 24h. </b>Vous recevrez prochainement un
      mail
      pour vous prévenir de leur disponibilité sur <b>votre espace MySeLogerPro.</b>
    </p>
    <h2>En attendant…</h2>
    <p>
      Vous pouvez vous rendre sur le catalogue de formations gratuites afin de maitriser pleinement nos solutions.
    </p>

    <a (click)="goToTrainingCatalog()" id="catalog-link">
      <button class="ui-btn primary-btn">Consulter le catalogue formation</button>
    </a>
  </div>

</div>

<ngx-smart-modal #sepaSignIframeModal identifier="sepaSignIframeModal" customClass="nsm-centered">
  <div class="modal-content">
    <iframe *ngIf="signatureService.getUrlSignatureSepa()" class="iframe-sepa" frameborder="0"
      [src]="signatureService.getUrlSignatureSepa()" (load)="onLoadIframe()">
    </iframe>
  </div>
</ngx-smart-modal>

<ngx-smart-modal #sepaFormExitModal identifier="sepaFormExitModal" customClass="nsm-centered">
  <div class="modal-header">
    <h2>Quitter le formulaire ?</h2>
  </div>
  <div class="modal-content">
    <p>En quittant la page, votre formulaire sera perdu.</p>
  </div>
  <div class="modal-footer">
    <button class="ui-btn secondary-btn" (click)="sepaFormExitModal.close()">Non</button>
    <button class="ui-btn primary-btn" (click)="onSepaFormExitConfirmed()">Oui, quitter</button>
  </div>
</ngx-smart-modal>
